import { render, staticRenderFns } from "./SampleTradeTable.vue?vue&type=template&id=6c971f42&"
import script from "./SampleTradeTable.vue?vue&type=script&lang=js&"
export * from "./SampleTradeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports